module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrap body"
  }, [_c('div', {
    staticClass: "login_head header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login_language pull-right"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.languageCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.languageStr)), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": {
        locale: 'zh'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.zh')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": {
        locale: 'en'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.en')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": {
        locale: 'ko'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.ko')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": {
        locale: 'ja'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.ja')))])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "notice_box"
  }), _vm._v(" "), _c('div', {
    staticClass: "login_bg"
  }, [_c('div', {
    staticClass: "login_main"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ms-login"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ms-login-title"
  }, [_vm._v(_vm._s(_vm.$t('login.userLogin')))]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "0px"
    }
  }, [_c('el-form-item', {
    staticClass: "username",
    attrs: {
      "prop": "loginName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('login.message1')
    },
    model: {
      value: (_vm.ruleForm.loginName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "loginName", $$v)
      },
      expression: "ruleForm.loginName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "password",
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    ref: "passwordInput",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('login.message2')
    },
    nativeOn: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm('ruleForm')
      }, function($event) {
        return (function (e) {
          e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, '')
          _vm.ruleForm.password = e.target.value
        }).apply(null, arguments)
      }]
    },
    model: {
      value: (_vm.ruleForm.password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "password", $$v)
      },
      expression: "ruleForm.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "forgot_box"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.rememberLoginStatus),
      callback: function($$v) {
        _vm.rememberLoginStatus = $$v
      },
      expression: "rememberLoginStatus"
    }
  }, [_vm._v(_vm._s(_vm.$t('login.rememberLoginStatus')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    attrs: {
      "to": "backAccount"
    }
  }, [_vm._v(_vm._s(_vm.$t('login.forgetPassword')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "login-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('login.loginIn')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "login-btn login-btn-new"
  }, [_c('router-link', {
    attrs: {
      "to": "selectMerchantType"
    }
  }, [_c('el-button', [_vm._v(_vm._s(_vm.$t('login.register')))])], 1)], 1)], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "login_copyright"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('login.copyRight'))), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn"
    }
  }, [_vm._v(_vm._s(_vm.$t('login.recordInformation')))]), _vm._v(" \n    "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://jph-static.oss-ap-northeast-1.aliyuncs.com/%E7%89%B9%E5%95%86%E6%B3%95%E8%A1%A8%E8%A8%98.pdf"
    }
  }, [_vm._v(_vm._s(_vm.$t('login.recordInformation2')))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login_logo pull-left"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/logo.svg"),
      "width": "120"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login_left_banner"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "https://greater-tokyo-pass.jp/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "swiper_banner",
    staticStyle: {
      "background-image": "url(/static/img/gtp3.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "https://www.hozugawakudari.jp/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "swiper_banner",
    staticStyle: {
      "background-image": "url(/static/img/11.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "http://www.fujisan.ne.jp/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "swiper_banner",
    staticStyle: {
      "background-image": "url(/static/img/fujisan.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "http://www.tobu.co.jp/foreign/en/pass/all.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "swiper_banner",
    staticStyle: {
      "background-image": "url(/static/img/nikkopass.png)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('div', {
    staticClass: "swiper_banner",
    staticStyle: {
      "background-image": "url(/static/img/tenku.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('div', {
    staticClass: "swiper_banner",
    staticStyle: {
      "background-image": "url(/static/img/ite.jpg)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login_logo_new"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assetts/images/login_logo.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc710b66","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/loginNew/loginNew.vue
// module id = 634
// module chunks = 128